<template>
    <div class="rkld">
        <div class="rkldRight">
            <div class="rkldRightContent">
                <!-- tabs导航 -->
                <el-tabs v-model="editableTabsValue" type="card">
                    <el-tab-pane label="消费记录" name="1">
                        <ul class="manage_header">
                            <li class="header_item">
                                <div style="width: 50%">
                                    <img
                                        style="width: 80%"
                                        src="../assets/img/afee.png"
                                        alt=""
                                    />
                                </div>
                                <div style="width: 50%">
                                    <h5>当月总营收</h5>
                                    <p class="price" style="color: #ed5565">
                                        {{ list.totalOrderMoney || 0 }}
                                    </p>
                                </div>
                            </li>
                            <li class="header_item">
                                <div style="width: 50%">
                                    <img
                                        style="width: 80%"
                                        src="../assets/img/bfee.png"
                                        alt=""
                                    />
                                </div>
                                <div style="width: 50%">
                                    <h5>当月线上营收</h5>
                                    <p class="price" style="color: #5470c6">
                                        {{ list.lineOrderMoney || 0 }}
                                    </p>
                                </div>
                            </li>
                            <li class="header_item">
                                <div style="width: 50%">
                                    <img
                                        style="width: 80%"
                                        src="../assets/img/cfee.png"
                                        alt=""
                                    />
                                </div>
                                <div style="width: 50%">
                                    <h5>当月线下营收</h5>
                                    <p class="price" style="color: #f7c65f">
                                        {{ list.underLineOrderMoney || 0 }}
                                    </p>
                                </div>
                            </li>
                            <li class="header_item">
                                <div style="width: 50%">
                                    <img
                                        style="width: 80%"
                                        src="../assets/img/atimes.png"
                                        alt=""
                                    />
                                </div>
                                <div style="width: 50%">
                                    <h5>当月订餐总数</h5>
                                    <p class="price" style="color: #4b4bb8">
                                        {{ list.orderCount || 0 }}
                                    </p>
                                </div>
                            </li>
                            <li class="header_item">
                                <div style="width: 50%">
                                    <img
                                        style="width: 80%"
                                        src="../assets/img/btimes.png"
                                        alt=""
                                    />
                                </div>
                                <div style="width: 50%">
                                    <h5>当月线上订餐数</h5>
                                    <p class="price" style="color: #23c6c8">
                                        {{ list.lineOrderCount || 0 }}
                                    </p>
                                </div>
                            </li>
                            <li class="header_item">
                                <div style="width: 50%">
                                    <img
                                        style="width: 80%"
                                        src="../assets/img/ctimes.png"
                                        alt=""
                                    />
                                </div>
                                <div style="width: 50%">
                                    <h5>当月线下订餐数</h5>
                                    <p class="price" style="color: #ed55ca">
                                        {{ list.underLineOrderCount || 0 }}
                                    </p>
                                </div>
                            </li>
                        </ul>
                        <!--搜索框-->
                        <div class="searchTj">
                            <div class="searchTjHead">
                                <span>查询条件</span>
                                <i
                                    class="searchDomw"
                                    @click="showSearch = !showSearch"
                                    :class="
                                        showSearch == true
                                            ? 'el-icon-arrow-up'
                                            : 'el-icon-arrow-down'
                                    "
                                ></i>
                            </div>
                            <el-form
                                :model="form"
                                class="searchTjContent"
                                v-show="showSearch"
                            >
                                <div class="searchTjContentDiv">
                                    <span
                                        class="searchTjContentDivSpan"
                                        style="margin-right: 0"
                                        >用户名</span
                                    >
                                    <el-input
                                        v-model="form.userName"
                                        placeholder="请输入"
                                        class="searchTjContentDivInput"
                                        clearable
                                    ></el-input>
                                </div>
                                <div class="searchTjContentDiv">
                                    <span class="searchTjContentDivSpan"
                                        >时间段</span
                                    >
                                    <el-date-picker
                                        v-model="form.dateSart"
                                        type="daterange"
                                        value-format="yyyy-MM-dd"
                                        @change="dateSartChange(form.dateSart)"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        clearable
                                    >
                                    </el-date-picker>
                                </div>
                                <div class="searchTjContentDiv">
                                    <el-button
                                        type="primary"
                                        icon="el-icon-search"
                                        class="searchBtns"
                                        @click="query"
                                        >查询
                                    </el-button>
                                </div>
                                <div class="searchTjContentDiv">
                                    <el-button
                                        type="info"
                                        icon="el-icon-delete"
                                        @click="resert"
                                        >清除条件
                                    </el-button>
                                </div>
                                <!-- <div
                  class='arrowDown'
                  @click='showSearch'
                  style='color: #000'
                >
                  <i class='el-icon-arrow-down'></i>
                </div> -->
                            </el-form>
                        </div>
                        <div class="searchButtonDiv" v-show="quanbu">
                            <div class="searchButtonDivLeft">
                                <!-- <div style="display: none">
                    <input @change="fileChange" id="speechUpload" type="file" />
                </div>
                <label for="speechUpload" class="labelImportBtn inDwonBtns">
                    <span> <i class="el-icon-upload2"></i>导入数据</span>
                </label>
                <el-button
                  type="primary"
                   icon="el-icon-sold-out" class="button modelDownds shuiBtn"
                  size="medium"
                  @click="downExcel"
                  >下载模板</el-button
                > -->
                            </div>
                            <!-- 筛选按钮 -->
                            <div class="searchButtonDiveRight">
                                <el-button-group>
                                    <el-button
                                        type="primary"
                                        icon="el-icon-refresh"
                                        @click="resertTable"
                                        class="dropRests"
                                    ></el-button>
                                    <!-- <el-button type="primary"> -->
                                    <el-dropdown
                                        class="dropdown"
                                        trigger="click"
                                        :hide-on-click="false"
                                    >
                                        <span class="el-dropdown-link">
                                            <i
                                                class="
                                                    el-icon-s-grid
                                                    el-icon--right
                                                "
                                                style="color: #fff"
                                            ></i>
                                            <i
                                                class="
                                                    el-icon-arrow-down
                                                    el-icon--right
                                                "
                                            ></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item>
                                                <template>
                                                    <el-checkbox-group
                                                        v-model="checkList"
                                                        :min="1"
                                                        @change="tableShow"
                                                    >
                                                        <el-checkbox
                                                            label="序号"
                                                            >序号
                                                        </el-checkbox>
                                                        <br />
                                                        <el-checkbox
                                                            label="用户编号"
                                                            >用户编号
                                                        </el-checkbox>
                                                        <br />
                                                        <el-checkbox
                                                            label="用户名"
                                                            >用户名
                                                        </el-checkbox>
                                                        <br />
                                                        <el-checkbox
                                                            label="消费金额"
                                                            >消费金额
                                                        </el-checkbox>
                                                        <br />
                                                        <el-checkbox
                                                            label="消费补贴金额"
                                                            >消费补贴金额
                                                        </el-checkbox>
                                                        <br />
                                                        <el-checkbox
                                                            label="消费时间"
                                                            >消费时间
                                                        </el-checkbox>
                                                        <br />
                                                        <el-checkbox
                                                            label="设备号"
                                                            >设备号
                                                        </el-checkbox>
                                                        <br />
                                                        <el-checkbox
                                                            label="消费方式"
                                                            >消费方式
                                                        </el-checkbox>
                                                        <br />
                                                        <el-checkbox
                                                            label="所属机构"
                                                            >所属机构
                                                        </el-checkbox>
                                                        <br />
                                                        <el-checkbox
                                                            label="卡号"
                                                            >卡号
                                                        </el-checkbox>
                                                        <br />
                                                        <!-- <el-checkbox label="操作">操作 </el-checkbox>
                            <br /> -->
                                                    </el-checkbox-group>
                                                </template>
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                    <!-- </el-button> -->
                                </el-button-group>
                            </div>
                        </div>
                        <div style="margin-bottom: 15px">
                            <el-button
                                icon="el-icon-download"
                                class="button downOutBtns"
                                type="medium"
                                style="color: #fff"
                                @click="createwayExcel"
                                >导出
                            </el-button>
                            <el-button
                                icon="el-icon-sold-out"
                                class="button modelDownds"
                                size="medium"
                                type="primary"
                                @click="createExcel"
                                >全部导出
                            </el-button>
                        </div>
                        <!--表单-->
                        <div class="addForm">
                            <el-table
                                ref="multipleTable"
                                :data="tableDate"
                                tooltip-effect="dark"
                                :header-cell-style="{
                                    background: '#e6e6e6',
                                    color: '#000',
                                }"
                                border
                                @selection-change="handleSelectionChange"
                                :row-key="
                                    (row) => {
                                        return row.id
                                    }
                                "
                            >
                                <el-table-column
                                    type="selection"
                                    width="50"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    type="index"
                                    width="70"
                                    label="序号"
                                    align="center"
                                    v-if="no1"
                                    show-overflow-tooltip
                                ></el-table-column>
                                <el-table-column
                                    prop="userNumber"
                                    label="用户编号"
                                    align="center"
                                    width="90"
                                    v-if="no2"
                                    show-overflow-tooltip
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="userName"
                                    label="用户名"
                                    align="center"
                                    width="100"
                                    show-overflow-tooltip
                                    v-if="no3"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="money"
                                    label="消费金额"
                                    align="center"
                                    width="100"
                                    show-overflow-tooltip
                                    v-if="no4"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="subsidy"
                                    label="消费补贴金额"
                                    width="120"
                                    align="center"
                                    show-overflow-tooltip
                                    v-if="no5"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="create_time"
                                    label="消费时间"
                                    align="center"
                                    show-overflow-tooltip
                                    v-if="no6"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="devGuid"
                                    label="设备号 "
                                    align="center"
                                    show-overflow-tooltip
                                    v-if="no7"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="operation"
                                    label="消费方式"
                                    align="center"
                                    width="240"
                                    show-overflow-tooltip
                                    v-if="no8"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="orgName"
                                    label="所属机构"
                                    align="center"
                                    width="240"
                                    show-overflow-tooltip
                                    v-if="no10"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="card"
                                    label="卡号 "
                                    align="center"
                                    show-overflow-tooltip
                                    v-if="no9"
                                >
                                </el-table-column>
                            </el-table>
                            <!-- 分页 -->
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :page-sizes="[10, 20, 40, 100]"
                                :page-size="query.pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total"
                            ></el-pagination>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>
<script>
import common from "../../../utils/common.js"
import request from "@/utils/request.js"
import request2 from "@/utils/request2.js"
import AMap from "AMap" // 引入高德地图
import { discriCard, chekCode, chekPhone } from "@/views/elderManage/util"
import baseURL from "@/api/baseURL"
import { Collapse } from "element-ui"
import { post } from "../../../api/requrestHttp"
export default {
    data() {
        var checkIdCode = (rule, value, callback) => {
            if (!chekCode(value)) {
                return callback(new Error("身份证号格式错误"))
            }
            const info = discriCard(value)
            this.addForm.customerSex = info.sex
            callback()
        }
        return {
            list: {},
            total: 0,
            pageNo: 1,
            pageSize: 10,
            dateSart: [],
            tableDate: [],
            form: {},
            showSearch: false,
            quanbu: true,
            // 筛选按钮功能控制表头是否显示初始状态
            no1: true,
            no2: true,
            no3: true,
            no4: true,
            no5: true,
            no6: true,
            no7: true,
            no8: true,
            no9: true,
            no10: true,
            editableTabsValue: "1",
            // 筛选数据功能按钮初始值
            checkList: [
                "序号",
                "用户编号",
                "用户名",
                "消费金额",
                "消费补贴金额",
                "消费时间",
                "设备号",
                "消费方式",
                "所属机构",
                "卡号",
                // "操作",
            ],
            selectedData: [],
        }
    },
    inject: ["reload"], //注入
    created() {
        this.getShow()
        this.sumNum()
    },
    methods: {
        async createwayExcel() {
            let ids = []
            if (this.selectedData.length > 0) {
                this.selectedData.forEach((item) => {
                    ids.push(item.id)
                })
                const res = await this.request2({
                    url: "sqyl/consumeRecord/info/consumeRecordPartExport",
                    method: "POST",
                    data: {
                        ids: ids,
                        userName: this.form.userName,
                        startTime: this.form.startTime,
                        endTime: this.form.endTime,
                    },
                    responseType: "blob",
                })
                const blob = new Blob([res], {
                    type: "application/vnd.ms-excel",
                })
                const fileName = "消费记录.xls"
                const linkNode = document.createElement("a")

                linkNode.download = fileName //a标签的download属性规定下载文件的名称
                linkNode.style.display = "none"
                linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
                document.body.appendChild(linkNode)
                linkNode.click() //模拟在按钮上的一次鼠标单击

                URL.revokeObjectURL(linkNode.href) // 释放URL 对象
                document.body.removeChild(linkNode)
                this.$refs.multipleTable.clearSelection()
            } else {
                this.$message.error("请选择")
            }
        },
        createExcel() {
            this.request2({
                url: "sqyl/consumeRecord/info/consumeRecordExport",
                method: "POST",
                excel: true,
                data: {
                    userName: this.form.userName,
                    startTime: this.form.startTime,
                    endTime: this.form.endTime,
                },
                responseType: "blob",
            }).then((res) => {
                if (res) {
                    const blob = new Blob([res], {
                        type: "application/vnd.ms-excel",
                    })
                    const fileName = "消费记录.xls"
                    const linkNode = document.createElement("a")
                    linkNode.download = fileName //a标签的download属性规定下载文件的名称
                    linkNode.style.display = "none"
                    linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
                    document.body.appendChild(linkNode)
                    linkNode.click() //模拟在按钮上的一次鼠标单击
                    URL.revokeObjectURL(linkNode.href) // 释放URL 对象
                    document.body.removeChild(linkNode)
                    this.$message.success("导出表格成功")
                }
            })
        },
        // 下载模板
        async downExcel() {
            const res = await request2({
                url: "/ypt/admin/basicPopulationPeople/info/downloadExcel",
                method: "POST",
                data: {
                    postName: "*",
                },
                responseType: "blob",
            })
            const blob = new Blob([res], { type: "application/vnd.ms-excel" })
            const fileName = "老年人数据.xls"
            const linkNode = document.createElement("a")

            linkNode.download = fileName //a标签的download属性规定下载文件的名称
            linkNode.style.display = "none"
            linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
            document.body.appendChild(linkNode)
            linkNode.click() //模拟在按钮上的一次鼠标单击

            URL.revokeObjectURL(linkNode.href) // 释放URL 对象
            document.body.removeChild(linkNode)
        },
        //导入数据
        async fileChange(event) {
            console.log(event)
            const file = event.target.files[0]
            console.log(file)
            const personType = "2"
            let config = {
                headers: { "Content-Type": "multipart/form-data" },
            }
            let formData = new FormData()
            formData.append("personType", personType)
            console.log(formData)
            formData.append("file", file)
            let result = await this.$http.post(
                "/ypt/admin/basicPopulationPeople/info/excel",
                formData,
                config
            )
            // 清空文件
            const fileEle = document.getElementById("speechUpload")
            fileEle.value = ""
            if (result.code == 200) {
                this.$message.success(result.message)
                this.getTableData()
            } else {
                this.$message.warning(result.message)
            }
        },
        dateSartChange(val) {
            if(val){
              this.form.startTime = val[0]
               this.form.endTime = val[1]
            }else{
                 this.form.startTime=""
                  this.form.endTime=""
            }
            
        },
        getShow() {
            this.$http
                .request({
                    url: "/sqyl/consumeRecord/info/findList",
                    method: "POST",
                    data: {
                        pageNo: this.pageNo,
                        pageSize: this.pageSize,
                        ...this.form,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content) {
                            this.tableDate = res.content.list
                            this.total = res.content.count
                        }
                    }
                })
        },
        handleSelectionChange(data) {
            this.selectedData = data
        },
        handleSelectionChange2() {},
        // 筛选功能按钮
        tableShow() {
            if (this.checkList.length > 0) {
                if (this.checkList.findIndex((obj) => obj == "序号") == -1) {
                    this.no1 = false
                } else {
                    this.no1 = true
                }
                if (
                    this.checkList.findIndex((obj) => obj == "用户编号") == -1
                ) {
                    this.no2 = false
                } else {
                    this.no2 = true
                }
                if (this.checkList.findIndex((obj) => obj == "用户名") == -1) {
                    this.no3 = false
                } else {
                    this.no3 = true
                }
                if (
                    this.checkList.findIndex((obj) => obj == "消费金额") == -1
                ) {
                    this.no4 = false
                } else {
                    this.no4 = true
                }
                if (
                    this.checkList.findIndex((obj) => obj == "消费补贴金额") ==
                    -1
                ) {
                    this.no5 = false
                } else {
                    this.no5 = true
                }
                if (
                    this.checkList.findIndex((obj) => obj == "消费补贴金额") ==
                    -1
                ) {
                    this.no6 = false
                } else {
                    this.no6 = true
                }
                if (
                    this.checkList.findIndex((obj) => obj == "消费时间") == -1
                ) {
                    this.no7 = false
                } else {
                    this.no7 = true
                }
                if (this.checkList.findIndex((obj) => obj == "设备号") == -1) {
                    this.no8 = false
                } else {
                    this.no8 = true
                }
                if (
                    this.checkList.findIndex((obj) => obj == "消费方式") == -1
                ) {
                    this.no8 = false
                } else {
                    this.no8 = true
                }
                if (this.checkList.findIndex((obj) => obj == "卡号") == -1) {
                    this.no9 = false
                } else {
                    this.no9 = true
                }
                if (
                    this.checkList.findIndex((obj) => obj == "所属机构") == -1
                ) {
                    this.no10 = false
                } else {
                    this.no10 = true
                }
                // if (this.checkList.findIndex((obj) => obj == "操作") == -1) {
                //   this.no7 = false
                // } else {
                //   this.no7 = true
                // }
            }
        },
        query() {
            this.getShow()
        },
        resert() {
            this.form = {}
            this.getShow()
        },
        // 表单刷新
        resertTable() {
            this.getShow()
            // this.checkList = [
            //     "序号",
            //     "姓名",
            //     "是否补助人员",
            //     "补贴方式",
            //     "餐补等级",
            //     "余额",
            //     "操作",
            // ]
            // this.tableShow()
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.getShow()
        },
        handleCurrentChange(val) {
            this.pageNo = val
            this.getShow()
        },
        // 统计
        sumNum() {
            post("/sqyl/consumeRecord/info/consumeRecordCount", {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
            }).then((res) => {
                // console.log(res);
                this.list = res.content
            })
        },
    },
}
</script>
<style lang='less' scoped>
// 新增功能模态框导航样式
.addFrom {
    .el-dialog__header {
        text-align: center;
    }

    .el-form-item__label {
        border: 1px solid #000;
    }

    .el-form-item {
        // dialog输入框居右对齐
        margin: 0;
        // 输入框
        input {
            height: 30px;
        }
    }

    // 新增功能模态框tabs
    .addDialogTabs {
        width: 100%;
        display: flex;
        font-size: 14px;
        justify-content: space-between;

        .borderBot {
            border-bottom: 2px solid #169bd5;
        }

        /deep/ .el-dialog__body {
            padding-top: 0px !important;
        }

        /deep/ .el-dialog__footer {
            text-align: center;
        }
    }

    .addDialogTabs > div {
        cursor: pointer;
        font-size: 14px;
        width: 50%;
        height: 50px;
        display: flex;
        margin-bottom: 10px;
        justify-content: center;
        align-items: center;
        border-bottom: 2px solid #e4e4e4;
    }

    .dialogBody {
        display: flex;
        // width: 100%;
        .dialogBodyright {
            width: 100%;
        }
    }

    /deep/ .el-dialog {
        /deep/ .el-dialog__header {
            border-bottom: 1px solid #e6e6e6;
        }

        /deep/ .el-dialog__body {
            padding-top: 0px !important;
        }
    }

    /deep/ .imgdialog {
        /deep/ .el-dialog__body {
            padding-top: 10px !important;
        }
    }

    // 模态框居住情况
    .dialogLiveRadio {
        display: flex;
        align-items: center;
    }
}

// 弹框底部
/deep/ .el-dialog .el-dialog__footer {
    background-color: #f5f5f5;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

/deep/ .el-upload--picture-card {
    width: 178px;
    height: 178px;
}

// --------------------------------------------
.rkld {
    display: flex;
    flex-direction: row;
    height: 100vh;
    overflow: hidden;
}

.rkldLeft {
    width: 234px;
    height: 100%;
    background: #37404f;
}

.rkldLeftLogo {
    background-color: rgb(55, 64, 79);
    height: 68px;
    width: 100%;
    display: flex;
    align-items: center;
    color: #ffffff;
}

.rkldLeftLogoImage {
    width: 39px;
    margin-left: 20px;
    margin-right: 10px;
}

.rkldRight {
    flex: 1;
    height: 100%;
    width: calc(100% - 266px);
    background-color: #ffffff;
}

.rkldRightHead {
    border-bottom: 1px solid #f5f5f5;
    width: 100%;
    background-color: #ececec;
    height: 69px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.mlIcon {
    height: 35px;
    width: 35px;
    font-size: 14px;
    margin-left: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: 3px;
}

.mlIcon:hover {
    background: rgba(0, 0, 0, 0.1);
}

::-webkit-scrollbar {
    display: none !important;
}

.rkldRightHeadRight {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 15px;
}

.demo-form-inline {
    padding: 0 5%;
}

.btnform {
    text-align: center;
}

.bodymsg {
    width: 140px;
    height: 40px;
    background-color: #ffb404;
    color: #fff;
    text-align: center;
    line-height: 40px;
    border-radius: 2px;
    margin-top: 20px;
    cursor: pointer;
}

.switchpage {
    display: inline-block;
    margin-bottom: 10px;
}

.activesiwtch {
    background-color: #d6d7d8;
}

.rkldRightHeadRightLeft {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 12px;
}

.rkldRightHeadRightLeft img {
    margin-right: 5px;
}

.rkldRightContent {
    height: calc(100% - 70px);
    overflow-y: auto;
    margin: 20px;
}

.searchTj {
    display: flex;
    flex-direction: column;
    position: relative;
    background: #f1f2f6;
    box-shadow: 0 0 6px rgba(151, 151, 151, 0.16);
    overflow: hidden;
    border-radius: 4px;
    margin: 5px;
}

.searchTjHead {
    background: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: rgb(0, 0, 0);
    border-color: rgb(217, 217, 217);
    padding: 6px 15px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
}

.searchTjContent {
    padding: 15px 20px 0px 5px;
    border: 1px solid rgb(217, 217, 217);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.searchTjContentDiv {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 40px;
    margin-bottom: 10px;
    border-radius: 4px;
}

.searchTjContentDivSpan {
    min-width: 58px;
    margin-right: 20px;
    font-size: 14px;
}

.searchTjContentDivInput {
    width: 20%;
    min-width: 196px;
}

/deep/ .arrowDown {
    width: 28px;
    height: 28px;
    background: #edf2f0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0px) 2s;
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
    // transition: 2s;
}

/deep/ .el-tabs__content {
    padding-bottom: 20px;
}

.searchButtonDiv {
    height: 54px;
    display: flex;
    margin-top: 14px;
    align-items: center;
    justify-content: space-between;
}

.searchButtonDivLeft {
    display: flex;
}

/deep/ .el-button {
    border-radius: 4px;
    padding: 0px 8px !important;
    border: none;
    height: 30px;
}

.el-button-group /deep/ .el-button--warning:last-child {
    border-left-color: rgba(255, 255, 255, 0.5);
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

/deep/ .el-pagination {
    margin-top: 10px;
}

/deep/ .el-submenu__title i {
    color: #fff;
}

.el-submenu /deep/ .el-menu-item {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/deep/ .el-submenu__title {
    border-bottom: 1px solid #2c3342;
    background: rgb(55, 64, 79) !important;
}

/deep/ .el-menu-item {
    border-bottom: 1px solid #2c3342;
    background: rgb(55, 64, 79) !important;
}

/deep/ .el-submenu.is-active /deep/ .el-submenu__title {
    border-bottom: 1px solid rgb(55, 64, 79);
}

/deep/
    .el-tabs--card
    > .el-tabs__header
    /deep/
    .el-tabs__item.is-active.is-closable {
    color: #0e2d5f;
}

/deep/ .el-menu .is-active {
    color: rgb(255, 255, 255) !important;
    background-color: #437ae1 !important;
}

/deep/ .el-submenu {
    width: 234px !important;
}

/deep/ .el-menu-item:hover {
    color: rgb(255, 255, 255) !important;
    background-color: #437ae1 !important;
}

/deep/ .tabBtn {
    margin: 0px;
}

.rkld .el-menu-vertical-demo:not {
    background: rgb(55, 64, 79) !important;
}

/* 用来设置当前页面element全局table 选中某行时的背景色*/
/deep/ .el-table__body tr.current-row > td {
    background-color: #fafad2 !important;
    color: #000;
}

/deep/ .el-table tbody tr:hover > td {
    background-color: #fafad2 !important;
}

.mapleft {
    margin-left: 10px;
    width: 200px;
    height: 400px;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: 5px;

    p {
        line-height: 42px;
        text-align: center;
    }
}

/deep/ .map_left {
    width: 100%;
    height: 400px;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: 5px;

    p {
        line-height: 42px;
        text-align: center;
    }
}

#myPageTop {
    position: absolute;
    top: -50px;
    right: 10px;
    background: #fff none repeat scroll 0 0;
    margin: 10px auto;
    padding: 6px;
    font-size: 14px;
}

#myPageTop input {
    width: 170px;
}

#myPageTop .column2 {
    padding-left: 25px;
}
.labelImportBtn {
    background: #23c6c8;
    border-radius: 3px;
    cursor: pointer;
    // margin: 0 10px;
    font-size: 12px;
    padding: 4px 5px;
    color: #fff;
    line-height: 28px;
    display: inline-block;
}
.shuiBtn {
    margin-left: 15px;
    padding: 10px 8px !important;
    height: 36px !important;
}
.manage_header {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 36px;
    .header_item {
        flex: 0 0 15%;
        padding: 24px 5px;
        display: flex;
        box-sizing: border-box;
        border-radius: 5px;
        background: #f2f3f4;
        &:not(:nth-child(6n + 1)) {
            margin-left: 2%;
        }
    }
    h5 {
        margin-bottom: 30px;
        color: #000000;
        font-size: 16px;
    }
    .price {
        padding-right: 40px;
        color: #41c0f5;
        font-size: 26px;
        font-weight: 400;
        text-align: center;
        font-family: Unidtrsmled;
    }
}
</style>
